import { toast } from "react-toastify";
import {
  getErrorMessage,
  addToOrder,
  addAffiliate,
} from "@ten24/slatwall-storefront-react-private/global";
import { axios, sdkURL } from "@ten24/slatwall-storefront-react-private/global";

const getCookie = (cname) => {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
};

const addToCartOrQuote = (
  skuID,
  quantity = 1,
  orderID = "",
  quoteName = ""
) => {
  return async (dispatch, getState) => {
    const accountCode = getState().cartReducer?.affiliateAccount?.accountCode;
    const affiliateAccountCookie = getCookie("affiliateCode");

    if (!accountCode?.length && affiliateAccountCookie.length) {
      const codePair = affiliateAccountCookie.split("=");
      dispatch(addAffiliate(codePair[1], "", false));
    }

    let params = {
      skuID,
      quantity,
    };

    if (orderID !== "") params["orderID"] = orderID;
    if (quoteName !== "") params["quoteName"] = quoteName;

    return dispatch(
      addToOrder({
        params: params,
      })
    ).then((response) => {
      if (
        response.isSuccess() &&
        Object.keys(response.success()?.errors || {}).length
      )
        toast.error(getErrorMessage(response.success().errors));
      if (response.isSuccess() && quoteName !== "")
        toast.success("Added to Quote");
      else if (response.isSuccess() && quoteName === "")
        toast.success("Added to Cart");
      if (!response.isSuccess()) toast.error("Error");

      return response;
    });
  };
};

const setAllCartOrQuotes = () => {
  return async (dispatch) => {
    var cartAndQuote = [];
    axios({
      method: "GET",
      url: `${sdkURL}api/scope/getCartAndDraftQuoteOrders`,
      data: {},
    }).then((response) => {
      if (
        response?.status === 200 &&
        response?.data?.failureActions.length === 0
      ) {
        cartAndQuote = response?.data?.cartQuoteOrders;
        dispatch({ type: "GET_ALL_CART_OR_QUOTE", cartAndQuote });
      }
    });
  };
};

export { addToCartOrQuote, setAllCartOrQuotes };
